import { makeAutoObservable } from "mobx";
import { ICompareValueStore } from "./compare-value-factory";
import IntegerCompareValueField from "../../components/policy-editor/policy-eligibility-card/condition-group-card/condition-builder/condition-field/compare-value-type-fields/integer-compare-value-field";

export interface ICompareValueNumber {
    value?: number;
}

class IntegerCompareValueStore implements ICompareValueStore<number|undefined> {
    private _model: ICompareValueNumber;
    private _changes: Partial<ICompareValueNumber> = {};
    private _uncommittedChanges: Partial<ICompareValueNumber> = {};

    constructor(compareValue?: string) {
        makeAutoObservable(this);
        this._model = { value: ensureValidNumber(compareValue) };
    }

    public onOperatorChanged(): void {
    }

    public setChanges(changes?: string) {
        if (changes) {
            this._changes = { value: ensureValidNumber(changes) };
        }
    }

    get Component() {
        return IntegerCompareValueField;
    }

    public get value() {
        return this._uncommittedChanges.value ?? this._changes.value ?? this._model.value;
    }

    public setValue(v: number) {
        this._uncommittedChanges.value = v;
    }

    public commitChanges(): void {
        this._changes = {...this._changes, ...this._uncommittedChanges};
        this._clearUnneededChanges();
    }

    public discardUncommittedChanges(): void {
        this._uncommittedChanges = {};
    }

    public hasChanges(): boolean {
        return !!Object.values(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public getUpdatedModel(): string|undefined {
        const updated = { ...this._model, ...this._changes };
        return updated.value?.toString();
    }

    public getUncommittedChanges() {
        return { ...this._model, ...this._changes, ...this._uncommittedChanges }?.value;
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof ICompareValueNumber;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default IntegerCompareValueStore;

export function ensureValidNumber(value: any): number|undefined {
    if (!isNaN(value)) {
        return Number(value);
    }

    return undefined;
}
